import { render, staticRenderFns } from "./ProductSalesPageTestimonialItem.vue?vue&type=template&id=1d258894&scoped=true&"
import script from "./ProductSalesPageTestimonialItem.vue?vue&type=script&lang=ts&"
export * from "./ProductSalesPageTestimonialItem.vue?vue&type=script&lang=ts&"
import style0 from "./ProductSalesPageTestimonialItem.vue?vue&type=style&index=0&id=1d258894&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d258894",
  null
  
)

export default component.exports